import type { ReactNode } from 'react';
import { Icon } from '../Icon';
import styles from './styles.module.css';

interface AddressStructuredFormatting {
  main_text: string;
  secondary_text?: string;
}

export interface Address {
  structured_formatting: AddressStructuredFormatting;
}

export interface AddressItemProps {
  address: Address;
}

export function AddressItem({ address }: AddressItemProps): ReactNode {
  return (
    <div className={styles.Address}>
      <Icon name="map-pin" />
      <div className={styles.AddressTexts}>
        <span>{address.structured_formatting.main_text}</span>
        <span className={styles.SecondaryText}>{address.structured_formatting.secondary_text}</span>
      </div>
    </div>
  );
}
